<template>
  <div class="flex flex-col items-center px-7 pb-14 pt-12 text-center">
    <div class="payment-spinner mb-6 h-16 w-16 rounded-full" />
    <div class="mb-1.5 text-subheader-2 font-black tracking-tight text-grey-800">
      Processing your payment
    </div>
    <p class="text-body-md font-medium text-grey-60">Please hold on a moment…</p>
  </div>
</template>

<script>
export default {
  name: 'PaymentProcessingStep',
};
</script>

<style scoped>
.payment-spinner {
  border: 5px solid theme('colors.brown.50');
  border-top-color: theme('colors.brown.800');
  animation: payment-spin 0.7s linear infinite;
}

@keyframes payment-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>
